// extracted by mini-css-extract-plugin
export default {"wrapper":"TravelCard_wrapper__OKkGN","isPast":"TravelCard_isPast__BUIEj","icon":"TravelCard_icon__2FzA8"};